import React  from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./PropertyAgentFullPage.css";
import "./PropertyAgentFullPageActual.css";
//import properties from "./properties.json";
import { SavedRow, } from "./types";
import { formatDecimalNumber, formatPrice, make_property_id, } from "./Utils";
import { FullPageIndexer } from './FullPageIndexer';
import FancyImageGallery from "./FancyImageGallery";
import ImageThumbnail from "./ImageThumbnail";
import { ImageCount } from "./ImageCount";
import FlatGallery from "./FlatGallery";
import { PropertyAPI } from "./lib/property-api";
import { get_source } from "./lib/source";

import { ImageGalleryEntry } from "./FlatGallery";
function presentMlsStatus(s: string | null) {
  if (!s) {
    return "";
  }
  s = s.toLowerCase();
  if (s === "expired") {
    return <b className="pafp-expired">Expired</b>;
  }
  if (s === "withdrawn") {
    return <b className="pafp-withdrawn">Withdrawn</b>;
  }
  if (s === "sold") {
    return <b className="pafp-sold">Sold</b>;
  }
  if (s === "active" || s === "pending") {
    return <b className="pafp-active">Active</b>;
  }
  return s;
}
function presentHalfBaths(br: number | null): string {
  if (br === null || br <= 0) {
    return "";
  }
  return String(br);
}

function presentYearBuilt(yr: number | null): string {
  if (yr === null || yr <= 0) {
    return "";
  }
  return String(yr);
}

function daysSince(dateString: string): number {
  const inputDate = new Date(dateString);
  const today = new Date();

  // Set both dates to start of the day to avoid partial day issues
  inputDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffTime = today.getTime() - inputDate.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
}
function presentDaysOnMarket(d: number | null): string {
  if (d === null || d < 0) {
    return "";
  }
  return String(d);
}

interface Props {
  property_id: string;
  do_print: boolean;
  done_loading: () => void;
}

function PropertyAgentFullPageActual(props: Props) {
  const [data, setData] = React.useState<SavedRow|null>();
  const [propertyID, setPropertyID] = React.useState<string>(props.property_id);
  const [stateZip,setStateZip] = React.useState<string>('');
  const [beds, setBeds] = React.useState<number | null>(null);
  const [baths, setBaths] = React.useState<number | null>(null);
  const [fullBaths, setFullBaths] = React.useState<number | null>(null);
  const [halfBaths, setHalfBaths] = React.useState<number | null>(null);
  const [squareFeet, setSquareFeet] = React.useState<string | null>(null);
  const [error, setError] = React.useState<string | null>(null);
  const [propertyType, setPropertyType] = React.useState<string | null>(null);
  const [propertySubType, setPropertySubType] = React.useState<string | null | string[]>(
    null
  );
  const [city,setCity] = React.useState<string|null>(null);
  const [unitNumber, setUnitNumber] = React.useState<string | null>(null);
  const [lotSize, setLotSize] = React.useState<string|null>(null);
  const [yearBuilt, setYearBuilt] = React.useState<number | null>(null);
  const [daysOnMarket, setDaysOnMarket] = React.useState<number>(-1);
  const [publicRemarks,setPublicRemarks] = React.useState<string|null>(null);
  const [agentRemarks,setAgentRemarks] = React.useState<string|null>(null);
  const [fullPageIndexer,_] = React.useState<FullPageIndexer>(new FullPageIndexer());
  const [isChecked,setIsChecked] = React.useState<boolean>(false);
  const [showImageGallery,setShowImageGallery] = React.useState<boolean>(false);
  const [imageCount,setImageCount] = React.useState<number>(0);
  const [doPrint,setDoPrint] = React.useState<boolean>(false);
  const [price,setPrice] = React.useState<string>('');
  const [mlsStatus, setMlsStatus] = React.useState<string | null>(null);
  const [address,setAddress] = React.useState<string>('');
  const [api,__] = React.useState<PropertyAPI>(new PropertyAPI());

  React.useEffect(() => {
    (async () => {
      const u: URL = new URL("https://lombardohomesandestates.com/");
      const is_staging: boolean = window.location.pathname.includes("/staging/");
      if (is_staging) {
        u.pathname = "/staging/";
        if(['localhost','0.0.0.0',].includes(window.location.hostname)){
          u.host = window.location.hostname;
          u.port = window.location.port;
          u.protocol = 'http';
        }
      } else {
        u.pathname = "/mls-properties/";
      }
      u.searchParams.set("viewMode", "icons");
      u.searchParams.set("displayMode", "property");
      u.searchParams.set("backDisplayMode", "show-active");
      u.searchParams.set("sortMode", "highest-first");
      //TODO: set this when we find the current index 
      //u.searchParams.set("listing", propertyID);
      //setMlsLink(u);
      if (typeof global.lombardo === "undefined") {
        global.lombardo = {
          selected: [],
        };
      }
      setPropertyID(props.property_id);
      setData(await api.get_property_by_source(props.property_id,get_source()));
      setDoPrint(props.do_print);
      await sanity_check_globals();
    })();
  }, []);
  async function sanity_check_globals(){
    const img_count: number|null = await ImageCount(props.property_id);
    if(img_count === null){
      setImageCount(0);
      props.done_loading();
    }else{
      setImageCount(img_count);
    }
    if(typeof global.lombardo.image_slots === 'undefined'){
      global.lombardo.image_slots = {};
    }
    global.lombardo.image_slots[props.property_id] = {
      count: img_count ?? 0,
      loaded: 0,
    };
  }
  React.useEffect(() => {
    (async () => {
      setPropertyID(props.property_id);
      let tmp: SavedRow|null = await api.get_property_by_source(props.property_id,get_source());
      setData(tmp);
      props.done_loading();
    })();
  },[props]);
  React.useEffect(() => {
    (async () => {
      if (!data){
        setError("Unable to find the listing you were looking for.");
        return;
      }
      setImageCount(data.Media.length);
      setCity(data.City ?? '');
      setYearBuilt(data.YearBuilt ?? '');
      if (typeof data.MlsStatus !== "undefined") {
        setMlsStatus(data.MlsStatus);
      }
      setError(null);
      {
        const sqft: string = data.LotSizeDimensions;
        setLotSize(sqft);
      }
      if(typeof data.LotSizeDimensions === 'undefined' || data.LotSizeDimensions === null || String(data.LotSizeDimensions).length === 0){
        setLotSize(null);
      }
      if(typeof data.LotSizeSquareFeet === 'number'){
        const sqft: string = formatDecimalNumber(data.LotSizeSquareFeet);
        if (sqft === "-1") {
          setSquareFeet(null);
        } else {
          setSquareFeet(sqft);
        }
      }else if(data.LotSizeSquareFeet === null || typeof data.LotSizeSquareFeet === 'string'){
        setSquareFeet(data.LotSizeSquareFeet);
      }else{
        setSquareFeet(null);
      }
      if (
        typeof data.BathroomsFull === "undefined" ||
        Number(data.BathroomsFull) === 0
      ) {
        setBaths(null);
      } else {
        setBaths(data.BathroomsFull);
        setFullBaths(data.BathroomsFull);
      }
      let half_baths: number = 0;
      if (
        typeof data.BathroomsHalf !== "undefined" ||
        Number(data.BathroomsHalf) > 0
      ) {
        half_baths = Number(data.BathroomsHalf);
        setHalfBaths(half_baths);
      }
      if (
        typeof data.BedroomsTotal === "undefined" ||
        Number(data.BedroomsTotal) === 0
      ) {
        setBeds(null);
      } else {
        let baths: number = Number(data.BedroomsTotal);
        if (half_baths) {
          baths += half_baths;
        }
        setBeds(baths);
      }
      let compiled_street: string[] = [];
      let zip: string|null = null;
      let state: string|null = null;
      let street_number: string|null=null;
      if (
        typeof data.StreetNumber !== "undefined" &&
        String(data.StreetNumber) !== "undefined"
      ) {
        compiled_street.push(String(data.StreetNumber));
        street_number = String(data.StreetNumber);
      }
      if (
        typeof data?.StreetName !== "undefined" &&
        String(data.StreetName) !== "undefined"
      ) {
        compiled_street.push(String(data.StreetName));
      }
      if (
        typeof data?.StreetSuffix !== "undefined" &&
        String(data.StreetSuffix) !== "undefined"
      ) {
        compiled_street.push(String(data.StreetSuffix));
      }
      let compiled_state: string[] = [];
      if (
        typeof data.PostalCity !== "undefined" &&
        String(data.PostalCity) !== "undefined"
      ) {
        compiled_state.push(String(data.PostalCity));
        setCity(String(data.PostalCity));
      }
      if (
        typeof data.StateOrProvince !== "undefined" &&
        String(data.StateOrProvince) !== "undefined"
      ) {
        compiled_state.push(String(data.StateOrProvince));
        state = String(data.StateOrProvince);
      }
      if (
        typeof data.PostalCode !== "undefined" &&
        String(data.PostalCode) !== "undefined"
      ) {
        compiled_state.push(String(data.PostalCode));
        zip = String(data.PostalCode);
      }
      setStateZip([state,zip].join("/"));
      setPropertyType(data.PropertyType);
      setPropertySubType(data.PropertySubType);
      let unit_number: string | null = null;
      if (typeof data.UnitNumber !== "undefined" && data.UnitNumber !== null) {
        unit_number = data.UnitNumber;
      }
      setUnitNumber(unit_number);
      if (
        data.OnMarketDate !== null &&
        String(data.OnMarketDate).match(/^\d{4}-\d{2}-\d{2}$/)
      ) {
        setDaysOnMarket(daysSince(String(data.OnMarketDate)));
      }
      setPublicRemarks(data.PublicRemarks);
      setIsChecked(fullPageIndexer.isSelected(propertyID));
      setPrice('');
      if(typeof data.AgentRemarks !== 'undefined'){
        setAgentRemarks(data.AgentRemarks);
      }else{
        setAgentRemarks(null);
      }
      if(typeof data.ListPrice !== 'undefined' && String(data.ListPrice) !== 'undefined'){
        setPrice(formatPrice(data.ListPrice));
      }
      if (unit_number) {
        setAddress(
          `${street_number !== null ? street_number + " " : ""}${data.StreetName} ${unit_number} ${data.StreetSuffix} ${data.PostalCity}, ${data.StateOrProvince} ${data.PostalCode}`
        );
      } else {
        setAddress(
          `${street_number !== null ? street_number + " " : ""}${data.StreetName} ${data.StreetSuffix} ${data.PostalCity}, ${data.StateOrProvince} ${data.PostalCode}`
        );
      }
    })();
  }, [props,data, propertyID, error,]);
  return (
    <div className="PropertyAgentFullPageActual pafp-font">
      {doPrint === true && (<div className="pafp-address">{address}</div>)}
      {doPrint === true && (
        <div className="pafp-checkbox-header pafp-spaced-out">
          <table className="pafp-hdr-table">
            <tr>
              <td className="pafp-hdr-label">MLS#:</td>
              <td className="pafp-hdr-value">{make_property_id(propertyID)}</td>
              <td className="pafp-hdr-label">Prop Type:</td>
              <td className="pafp-hdr-value">{propertyType}</td>
              <td className="pafp-hdr-label-slim">Price:</td>
              <td className="pafp-hdr-value-slim">{price}</td>
            </tr>
            <tr>
              <td className="pafp-hdr-label">Status:</td>
              <td className="pafp-hdr-value">{presentMlsStatus(mlsStatus)}</td>
              <td className="pafp-hdr-label">Sub Type:</td>
              <td className="pafp-hdr-value">{Array.isArray(propertySubType) && (propertySubType.join(','))}
                {Array.isArray(propertySubType) === false && (propertySubType)}
              </td>
            </tr>
          </table>
        </div>
      )}
      <section className="pafp-header-info">
        <div className="pafp-left-right-split">
          {imageCount > 0 && (
            <div className="pafp-img-gallery">
              <a className="pafp-image-gallery-link" href="#" onClick={() => {
                setShowImageGallery(true);
                }}>
                <ImageThumbnail property_id={props.property_id} source={get_source()}/>
                <br/>
                <span className="no-print">Click for Image Gallery</span>
              </a>
              <div className={"pafp-img-backdrop " + (showImageGallery ? "pafp-fimg-show" : "pafp-fimg-hidden")} onClick={() => {
                setShowImageGallery(false);
                }}></div>
              <div className={"pafp-floating-img-gallery " + (showImageGallery ? "pafp-fimg-show" : "pafp-fimg-hidden")}>
                <FancyImageGallery property_id={props.property_id} source={get_source()}/>
              </div>
            </div>
          )}
          {imageCount === 0 && (
            <div className="pafp-img-gallery-no-images no-print">
              There are no images for this property
            </div>)}
          <div className="pafp-property-details">
            <table>
              <tr>
                <td className="pafp-pd-label">City:</td>
                <td className="pafp-pd-value">{city}</td>
                <td className="pafp-pd-label">State/Zip:</td>
                <td className="pafp-pd-value">{stateZip}</td>
              </tr>
              <tr>
                {lotSize !== null && (<td className="pafp-pd-label">Lot Size:</td>)}
                {lotSize !== null && (<td className="pafp-pd-value">{lotSize}</td>)}
                {squareFeet !== null && squareFeet !== '0' && (<td className="pafp-pd-label">Liv Sqft:</td>)}
                {squareFeet !== null && squareFeet !== '0' && (<td className="pafp-pd-value">{squareFeet}</td>)}
              </tr>
              <tr>
                <td className="pafp-pd-label">Bedrooms:</td>
                <td className="pafp-pd-value">{beds}</td>
                {yearBuilt !== null && yearBuilt !== 0 && (<td className="pafp-pd-label">Year Built:</td>)}
                {yearBuilt !== null && yearBuilt !== 0 && (<td className="pafp-pd-value">{presentYearBuilt(yearBuilt)}</td>)}
              </tr>
              <tr>
                <td className="pafp-pd-label">Baths:</td>
                <td className="pafp-pd-value">{baths}</td>
                <td className="pafp-pd-label">Half Baths:</td>
                <td className="pafp-pd-value">{presentHalfBaths(halfBaths)}</td>
              </tr>
              <tr>
                <td className="pafp-pd-label">Full Baths:</td>
                <td className="pafp-pd-value">{fullBaths}</td>
                {daysOnMarket !== null && daysOnMarket > 0 && (<td className="pafp-pd-label">Days On Market:</td>)}
                {daysOnMarket !== null && daysOnMarket > 0 && (<td className="pafp-pd-value">{presentDaysOnMarket(daysOnMarket)}</td>)}
              </tr>
              <tr>
                {propertyType !== null && (<td className="pafp-pd-label">Property Type:</td>)}
                {propertyType !== null && (<td className="pafp-pd-value">{propertyType}</td>)}
                <td className="pafp-pd-label prop-sub-type">Property Sub Type:</td>
                <td className="pafp-pd-value prop-sub-type">{Array.isArray(propertySubType) && (propertySubType.join(','))}
                  {Array.isArray(propertySubType) === false && (propertySubType)}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </section>
      {publicRemarks !== null && String(publicRemarks).length > 0 && (
      <section className="pafp-header-info">
        <div className="pafp-section-title">Public Remarks</div>
        <p className="pafp-public-remarks">
          {publicRemarks}
        </p>
      </section>)}
      {agentRemarks !== null && (<section className="pafp-header-info">
        <div className="pafp-section-title">Agent Remarks</div>
        <p className="pafp-public-remarks">
          {agentRemarks}
        </p>
      </section>)}
      <section className="pafp-header-info">
        <div className="pafp-section-title">Agent/Broker Info</div>
        <table>
          <tr>
            <td className="pafp-pd-label">List Office:</td>
            <td className="pafp-pd-value">Lombardo Homes &amp; Estates (FRHO01)</td>
            <td className="pafp-pd-label">List Office Address:</td>
            <td className="pafp-pd-value">195 San Juan Dr, Hauppauge, NY 11788</td>
          </tr>
          <tr>
            <td className="pafp-pd-label">List Agent:</td>
            <td className="pafp-pd-value">Joseph V. Lombardo CBR (97475)</td>
            <td className="pafp-pd-label">Office ID:</td>
            <td className="pafp-pd-value">FRHO01</td>
          </tr>
          <tr>
            <td className="pafp-pd-label">Office Broker:</td>
            <td className="pafp-pd-value">Joseph V. Lombardo CBR (97475)</td>
            <td className="pafp-pd-label">NRDS ID:</td>
            <td className="pafp-pd-value">641582291</td>
          </tr>
          <tr>
            <td className="pafp-pd-label">Office Phone:</td>
            <td className="pafp-pd-value"><a href="tel:5162006448">516-200-6448</a></td>
            <td className="pafp-pd-label">Office Fax:</td>
            <td className="pafp-pd-value">516-407-5520</td>
          </tr>
          <tr>
            <td className="pafp-pd-label">Email:</td>
            <td className="pafp-pd-value"><a href="email:info@LHENY.COM">info@LHENY.COM</a></td>
            <td className="pafp-pd-label">Website:</td>
            <td className="pafp-pd-value"><a href="https://www.lombardohomesandestates.com">https://www.lombardohomesandestates.com</a></td>
          </tr>
        </table>
      </section>
      {doPrint === true && (<div className="pafp-print-img-gallery">
        <FlatGallery property_id={propertyID} full_sized={false} loaded_image={(_: ImageGalleryEntry) => {
          if(typeof global.lombardo.image_slots[props.property_id] === 'undefined'){
            global.lombardo.image_slots[props.property_id] = {
              loaded: 0,
            };
          }
          global.lombardo.image_slots[props.property_id].loaded += 1;
          if(global.lombardo.image_slots[props.property_id].count === global.lombardo.image_slots[props.property_id].loaded){
            props.done_loading();
          }
          }}
          source={get_source()}
        />
      </div>)}
    </div>
  );
}

export default PropertyAgentFullPageActual;
